export const getAuthHeader = (): string => {
	try {
		const authData = localStorage.getItem("persist:root");
		if (!authData) return "";

		const parsed = JSON.parse(authData);
		if (!parsed.auth) return "";

		const auth = JSON.parse(parsed.auth);
		const accessToken = auth?.data?.access_token;

		return accessToken ? `Bearer ${accessToken}` : "";
	} catch (error) {
		console.error("Failed to retrieve access token from localStorage:", error);
		return "";
	}
};
